<template>
    <div>

        <div class="img-content">
            <img src="../assets/images/main.jpg" alt="">
        </div>

        <div class="font">
            <!-- 顶部文字 -->
            <span>防伪查询</span>

            <!-- 地址 -->
            <p>SECURITY CHECK</p>

            <!-- 邮箱 -->
            <p>打开微信扫一扫->防伪二维码->进入防伪查询系统</p>


        </div>

        <!-- 图片及文字说明 -->
        <div class="QRimg">
            <div>
                <img src="../assets/images/query.jpg" alt="QR Code 3">
                <p>扫码查真伪</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactUsPage'
};
</script>

<style scoped>
/* 移动端 */
@media only screen and (max-width: 996px) {
    .font {
        margin-top: 100px;
        width: 100%;
        text-align: center;
        line-height: 80px;
    }

    .font p {
        font-size: 1rem;
    }

    .font span {
        font-size: 1.3rem;
        font-weight: bold;
    }
}

/* 桌面端 */
@media only screen and (min-width: 996px) {
    .font {
        font-size: 20px;
        margin-top: 100px;
        width: 100%;
        text-align: center;
        line-height: 80px;
    }
}

/* 样式 */
.img-content {
    text-align: center;
}

/* .img-content img {
  width: 50%;
} */


.QRimg {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
}

.QRimg div {
    text-align: center;
    margin: 10px;
    /* 调整图片之间的间距 */
}

.QRimg img {
    width: 80%;
}</style>